import React from "react";
import { Star, ExternalLink } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { COMPANY } from "@/lib/translations";

const Reviews = () => {
  const { t } = useLang();
  const rating = COMPANY.googleRating;
  const fullStars = Math.floor(rating);

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative py-24 sm:py-32 bg-[color:var(--bg-primary)] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <p className="label-eyebrow">{t.reviews.eyebrow}</p>
            <h2
              data-testid="reviews-title"
              className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 text-white tracking-tight"
            >
              {t.reviews.title}
            </h2>
            <p className="mt-6 text-zinc-400 leading-relaxed">{t.reviews.summary}</p>
          </div>

          <div className="lg:col-span-7">
            <div className="bento-card p-8 sm:p-10 flex flex-col sm:flex-row items-start sm:items-center gap-8">
              <div className="flex-1">
                <div className="flex items-baseline gap-3">
                  <span
                    data-testid="reviews-rating"
                    className="font-display text-5xl sm:text-6xl gold-text leading-none"
                  >
                    {rating.toFixed(1)}
                  </span>
                  <span className="text-zinc-400 text-sm">/ 5.0</span>
                </div>
                <div className="mt-3 flex items-center gap-1">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <Star
                      key={i}
                      className="h-5 w-5"
                      fill={i < fullStars ? "#d4af37" : "transparent"}
                      stroke="#d4af37"
                      strokeWidth={1.5}
                    />
                  ))}
                </div>
                <p className="mt-4 text-[10px] tracking-[0.25em] uppercase text-zinc-500">
                  {t.reviews.ratingLabel} · {COMPANY.googleReviewsCount}
                </p>
              </div>

              <a
                href={COMPANY.googleReviewsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-google-link"
                className="btn-outline whitespace-nowrap"
              >
                {t.reviews.reviewsLabel}
                <ExternalLink className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
